import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { LockKeyhole } from "lucide-react";
import { toast } from "react-toastify";
import { updateUserPassword } from "../../services/firestoreService";
import { useAuth } from "../../hooks/useAuth";

const ChangePasswordPage = () => {
  // --- NOVO: Pegamos a função 'refreshUserData' do contexto ---
  const { refreshUserData } = useAuth();

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(6, "A senha deve ter no mínimo 6 caracteres.")
      .required("A nova senha é obrigatória."),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "As senhas não correspondem.")
      .required("A confirmação da senha é obrigatória."),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await updateUserPassword(values.newPassword);
      // --- NOVO: Forçamos a atualização dos dados do usuário no contexto ---
      await refreshUserData();
      toast.success("Senha atualizada com sucesso! Redirecionando...");
      // A navegação agora é automática pelo ProtectedRoute, não precisamos mais dela aqui.
    } catch (error) {
      console.error("Erro ao atualizar a senha:", error);
      toast.error(`Não foi possível atualizar sua senha: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <LockKeyhole className="mx-auto h-12 w-12 text-brand-blue" />
          <h1 className="mt-4 text-3xl font-bold text-light-text-primary dark:text-dark-text-primary">
            Crie sua nova senha
          </h1>
          <p className="mt-2 text-sm text-light-text-secondary dark:text-dark-text-secondary">
            Por segurança, como este é seu primeiro acesso, você precisa definir
            uma senha pessoal.
          </p>
        </div>

        <Formik
          initialValues={{ newPassword: "", confirmPassword: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="space-y-6">
              <div className="space-y-2">
                <label
                  htmlFor="newPassword"
                  className="block text-sm font-medium text-light-text-primary dark:text-dark-text-primary"
                >
                  Nova Senha
                </label>
                <Field
                  type="password"
                  name="newPassword"
                  className="block w-full px-3 py-2 border border-light-border dark:border-dark-border rounded-md shadow-sm bg-light-card dark:bg-dark-bg focus:outline-none focus:ring-brand-blue focus:border-brand-blue"
                />
                <ErrorMessage
                  name="newPassword"
                  component="p"
                  className="text-xs text-brand-red"
                />
              </div>
              <div className="space-y-2">
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm font-medium text-light-text-primary dark:text-dark-text-primary"
                >
                  Confirme a Nova Senha
                </label>
                <Field
                  type="password"
                  name="confirmPassword"
                  className="block w-full px-3 py-2 border border-light-border dark:border-dark-border rounded-md shadow-sm bg-light-card dark:bg-dark-bg focus:outline-none focus:ring-brand-blue focus:border-brand-blue"
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="p"
                  className="text-xs text-brand-red"
                />
              </div>
              <div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-blue hover:bg-brand-blue/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue disabled:opacity-50"
                >
                  {isSubmitting ? "Salvando..." : "Salvar Nova Senha"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
